module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step2_Image28.2d8cb7ec.jpg";